import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { fetchTeamMemberById } from './teamMembers.api'

export function useTeamMemberById(memberId: string | null, enabled: boolean) {
  const id = memberId ?? ''
  return useQuery({
    queryKey: queryKeys.team.member(id || '__none__'),
    queryFn: () => fetchTeamMemberById(id),
    enabled: Boolean(enabled && memberId),
    staleTime: 30_000,
  })
}
